document.querySelectorAll('[data-module-description]').forEach((wrapper) => {
  const description = wrapper.querySelector('[data-description="content"]');
  const button = wrapper.querySelector('[data-description="button"]');

  if (!description || !button || description.scrollHeight <= description.clientHeight) return;

  wrapper.classList.add('is-collapsible');
  button.addEventListener('click', () => {
    const isExpanded = wrapper.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', isExpanded);
    button.querySelector('span').textContent = isExpanded ? button.dataset.readLessLabel : button.dataset.readMoreLabel;
  });
});